import { Tooltip } from '../../../iba-components/Tooltip'
import { Link } from '../../../iba-components/Link'
import styles from './index.module.css'

const HelpMenuTip = ({ t }) => {
    const helpNavList = [
        {
            label: t('common.aboutTheService'),
            path: '/v2/support/about-the-service'
        },
        { label: t('common.howToUse'), path: '/v2/support/how-to-use' },
        { label: t('common.glossary'), path: '/v2/support/glossary' }
    ]

    return (
        <ul className={styles.help_inner}>
            {helpNavList.map((item) => (
                <li key={item.path}>
                    <Link href={item.path} target="_blank" label={item.label} isBorder />
                </li>
            ))}
        </ul>
    )
}

export const HelpMenu = ({ t }) => {
    return (
        <div className={styles.container}>
            <Tooltip content={<HelpMenuTip t={t} />} trigger="click" position="bottom-left">
                <div className={styles.help}>
                    <span className={`Appkit4-icon icon-help-question-outline ${styles.help_icon}`} />
                    Help
                </div>
            </Tooltip>
        </div>
    )
}
